import { render } from "./dataTablesComponent.vue?vue&type=template&id=8b790244&scoped=true"
import script from "./dataTablesComponent.vue?vue&type=script&lang=js"
export * from "./dataTablesComponent.vue?vue&type=script&lang=js"

import "./dataTablesComponent.vue?vue&type=style&index=0&id=8b790244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b790244"]])

export default __exports__